import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetSendOutDetailQuery, useUpdateSendOutMutation } from "store/services/sendOutApi";
import SendOutForm from "./SendOutComponent/SendOutForm";

const SendOutEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Send Out", path: "/app/crm/sendOut/list" },
    { title: "Edit Send Out" },
  ];

  const {
    data: sendOutDetail,
    isLoading: loadingSendOut,
    error,
  } = useGetSendOutDetailQuery(id);

  const [updateSendOut, { isLoading: updatingSendOut }] = useUpdateSendOutMutation();

  const handleUpdateSendOut = async (data) => {
    const _payload = { ...data, _id: id };

    try {
      await updateSendOut(_payload).unwrap();
      toast.success("Send Out successfully updated!");
      navigate(`/app/crm/sendOut/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Send Out!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingSendOut || updatingSendOut}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <SendOutForm
          isBusy={loadingSendOut || updatingSendOut}
          sendOutDetail={sendOutDetail}
          onSubmit={handleUpdateSendOut}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SendOutEditScreen;
